// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3-o_5","list":"BalanceDue_list__2TUmW","listRow":"BalanceDue_listRow__IGVwN","total":"BalanceDue_total__2cWN6"};